export const buttonFormat = (msg) => {
	const MsgList = msg.pop();

	const formatRes = {
		recipient_id: "",
		text: "",
		buttons: [],
	};

	formatRes.recipient_id = MsgList.recipient_id;
	formatRes.text = MsgList.custom.attachments[0].content.body[0].text || "";
	MsgList.custom.attachments[0].content.actions.map((item) => {
		formatRes.buttons.push({
			type: item.data.msteams.type,
			title: item.title,
			payload: item.data.msteams.value,
		});
		return false;
	});

	if (msg.length > 1) {
		return msg.concat([formatRes]);
	} else {
		return [formatRes];
	}
};

export const dateFormat = (msg) => {
	const MsgList = msg.pop();

	const formatRes = {
		recipient_id: "",
		dateText: "",
	};
	formatRes.recipient_id = MsgList.recipient_id;
	formatRes.dateText = MsgList.custom.attachments[0].content.body[0].text;
	if (msg.length > 1) {
		return msg.concat([formatRes]);
	} else {
		return [formatRes];
	}
};

// Card data
export const cardFormat = (msg, type) => {
	const MsgList = msg.pop();
	const formatRes = {
		recipient_id: MsgList.recipient_id,
		cardList: MsgList.custom.attachments,
		cardType: type,
	};
	const text = {
		recipient_id: msg.recipient_id,
		text: "Here are the search results based on your selection.",
	};

	return [msg[0], text, formatRes];
};

export const newBooking = (msg, type) => {
	const MsgList = msg.pop();
	const formatRes = {
		recipient_id: MsgList.recipient_id,
		cardList: MsgList.custom,
		cardType: type,
	};

	return [msg[0], formatRes];
};

export const cancelFormat = (msg, type) => {
	const MsgList = msg.pop();
	const formatRes = {
		recipient_id: MsgList.recipient_id,
		cardList: MsgList.custom.attachments[0],
		cardType: type,
	};

	return [msg[0], formatRes];
};

export const itineraryFormat = (msg, type) => {
	const MsgList = msg.pop();
	const formatRes = {
		recipient_id: MsgList.recipient_id,
		cardList: MsgList.custom,
		cardType: type,
	};

	return msg.concat(formatRes);
};

export const humanHandoffFormat = (msg) => {
	const MsgList = msg.pop();
	const formatRes = {
		recipient_id: MsgList.recipient_id,
		human: MsgList.custom || "",
	};

	return msg.concat([formatRes]);
};

export const changeFormat = (msg, type) => {
	const MsgList = msg.pop();
	const cardData = {
		FLIGHT: MsgList.custom.CHANGE_QUERY_OPTIONS.FLIGHT.map((item) => {
			return {
				...item,
				changeDate: item.dep_time,
			};
		}),
		HOTEL: MsgList.custom.CHANGE_QUERY_OPTIONS.HOTEL.map((item) => {
			return {
				...item,
				changeCheckInDate: item.checkInDate,
				changeCheckOutDate: item.checkOutDate,
			};
		}),
		CAR: MsgList.custom.CHANGE_QUERY_OPTIONS.CAR.map((item) => {
			return {
				...item,
				changePickUpDate: item.pickUpDate + item.pickUpTime,
				changeDropOffDate: item.dropOffDate + item.dropOffTime,
			};
		}),
	};
	const formatRes = {
		recipient_id: MsgList.recipient_id,
		cardList: cardData,
		cardType: type,
	};

	return msg.concat(formatRes);
};

export const changeHotelFormat = (msg, type) => {
	const MsgList = msg.pop();

	const formatRes = {
		recipient_id: MsgList.recipient_id,
		cardList: MsgList.custom.HOTEL_ROOMS,
		cardType: type,
	};

	const text = {
		recipient_id: msg.recipient_id,
		text: MsgList.custom.text,
	};

	return msg.concat([text, formatRes]);
};

export const changeFlightFormat = (msg, type) => {
	const MsgList = msg.pop();

	const formatRes = {
		recipient_id: MsgList.recipient_id,
		cardList: MsgList.custom.FLIGHT_OPTIONS,
		cardType: type,
	};

	const text = {
		recipient_id: msg.recipient_id,
		text: MsgList.custom.text,
	};

	return msg.concat([text, formatRes]);
};
